export default {
  /* Global */
  // 设置用户信息
  SET_USER_INFO: 'SET_USER_INFO',
  // 设置用户权限
  SET_USER_PRIVILEGE: 'SET_USER_PRIVILEGE',

  /* Statistics */
  // 设置系统列表
  SET_SYSTEM_LIST: 'SET_SYSTEM_LIST',

  /* 设置全局伸缩变量 */
  TOGGEL_IS_COLLAPSE: 'TOGGEL_IS_COLLAPSE'

}
